import styled from 'styled-components';

//game-info-jackpot game-preview
export const GameJackpotPreviewDefaultBox = styled.div`
    width: 100%;
`;